// Mock responses for ChatSidebar - extracted from ChatSidebar.jsx
// Note: This is separate from ChatOverlay mockResponses as they may diverge in functionality

export const mockResponses = {
  "how's my traffic": {
    content: "Your site traffic is looking strong! In the last 28 days, you gained **1,470 clicks** (↑15.2%) and **42,300 impressions** (↑8.7%). Your average position improved to **12.4** (↑2.1 positions).\n\n**Key highlights:**\n• Top performing page: `/blog/seo-guide` (340 clicks)\n• Biggest gainer: `/services/consulting` (+89 clicks)\n• Strong mobile performance (67% of traffic)\n\nWould you like me to dive deeper into any specific area?",
    suggestions: [
      "Which pages are driving this growth?",
      "Run a full site audit",
      "Compare to last quarter"
    ],
    toolsUsed: ['get_search_console_summary']
  },
  "what about this page": {
    content: "This page `/blog/seo-guide` is performing exceptionally well! It gained **170 clicks** (↑23%) and moved up to position **#3** for its main keyword.\n\n**Performance breakdown:**\n• **Keywords:** Ranking for 47 terms (12 in top 10)\n• **CTR:** 4.2% (above average for position #3)\n• **Top keyword:** \"SEO guide\" (position #3, 89 clicks)\n• **Opportunity:** \"beginner SEO\" (position #11, high impressions)\n\n**Quick wins:**\n• Add internal links from related blog posts\n• Optimize for \"beginner SEO\" to push into top 10\n• Consider adding FAQ section for long-tail keywords",
    suggestions: [
      "How can I improve this page's ranking?",
      "Show me competing pages",
      "Run content audit on this page"
    ],
    contextDetected: "Page Analysis: /blog/seo-guide"
  },
  "run site audit": {
    content: "I'd be happy to help you run a comprehensive site audit! Based on your current setup, I recommend the **Technical SEO Audit** which will check:\n\n**What it covers:**\n• ✅ Crawlability and indexation issues\n• ✅ Page speed and Core Web Vitals\n• ✅ Mobile-friendliness\n• ✅ Schema markup opportunities\n• ✅ Internal linking structure\n• ✅ Duplicate content detection\n\n**Estimated time:** 5-10 minutes\n**Best for:** Identifying technical issues that might be holding back your rankings\n\nShould I start the audit now, or would you like to explore other audit options first?",
    suggestions: [
      "Start Technical SEO Audit",
      "Show me other audit types",
      "What's my biggest SEO issue?"
    ],
    reportRecommended: "Technical SEO Audit"
  },

};
